import { MatchDayResultsModel, emptyMatchDayResultsModel } from './MatchDayResultsModel';

export interface LastMatchDayResultsWidgetState {
  isFetched: boolean;
  lastMatchDayResults: MatchDayResultsModel;
}

export const emptyLastMatchDayResultsWidgetState: LastMatchDayResultsWidgetState = {
  isFetched: false,
  lastMatchDayResults: emptyMatchDayResultsModel,
};
